module.exports = __webpack_public_path__ + "images/category_lp/alcohol/assessment_achievements/3_7058d106c4e42c358ef71d62db042498.jpg";